module.exports = __webpack_public_path__ + "h5/img/bargainBg.6c428ff8.png";